import { ALL_CITIES } from '@src/app/modules/search-cities';

import { LoyaltyProgramCategory, LoyaltyProgramProductInput } from './models';

export const NEW_CATEGORY_ITEM: LoyaltyProgramCategory = {
  id: 'new',
  imageURL: 'assets/images/loyalty-program/icon-new.png',
  name: 'Новые',
  link: '/loyalty/collections/new',
};
export const INIT_PRODUCT = { cities: [ALL_CITIES] } as LoyaltyProgramProductInput;
